import { isEqual } from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
} from "../../../common_components/common_widgets/popup";
import DocumentManagement from "../../../common_components/document-management/component";
import { SET_IS_STOP_DOCUMENT_POLLING } from "../../../common_components/document-management/reducers/document-management-reducer";
import {
  FG_ALL_AUDIT_VIEWER,
  FG_AUDIT_A_CASE,
  FG_AUDIT_VIEWER,
  hasAnyFeatureGroupAccess,
} from "../../../common_components/user-permissions-helper";
import { TOGGLE_DOCUMENT_MANAGEMENT_POPUP } from "./reducers/audit-list-reducer";

const DocumentManagementPopup: React.FC<any> = (props) => {
  let currentSelectedRowId = useSelector(
    (state: any) => state.auditListReducer.currentSelectedRowId,
    isEqual
  );
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const isDocumentManagementPopupVisible = useSelector(
    (state) => state["auditListReducer"].isDocumentManagementPopupVisible,
    isEqual
  );
  const documentManagementPopupTitle = useSelector(
    (state) => state["auditListReducer"].documentManagementPopupTitle,
    isEqual
  );

  const hasAuditViewAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_AUDIT_A_CASE, FG_AUDIT_VIEWER, FG_ALL_AUDIT_VIEWER],
        currentUser
      ),
    [currentUser]
  );

  const getSamplePopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          props.toggleDocumentManagementPopupVisible(false);
        }}
      >
        {documentManagementPopupTitle}
      </MdaePopupTitle>
    );
  };

  return (
    <MdaePopup
      deferRendering={false}
      maxWidth={1200}
      height={600}
      onHidden={(e) => {
        dispatch({
          type: SET_IS_STOP_DOCUMENT_POLLING,
          isStopDocumentPooling: true,
        });
      }}
      mdaeTitleRender={getSamplePopupTitle}
      visible={isDocumentManagementPopupVisible}
      mdaeContentRender={() => {
        return (
          <div>
            <DocumentManagement
              hasAuditViewAccess={hasAuditViewAccess}
              isManagerView={false}
              showForCoderReviewInd={false}
              attachedLevelId={currentSelectedRowId}
              attachedLevelName={"EA"}
              isIncludeNonAuditLevelDocumentCheckBoxVisible={true}
            />
            ;
          </div>
        );
      }}
    ></MdaePopup>
  );
};

export default DocumentManagementPopup;
